import { TreeMenuModel } from 'app/models/core/tree.node.model';
import { computed, makeObservable, reaction } from 'mobx';
import { AgenturStore } from '../agentur.store';
import { AgtGpStore } from '../agt.gp.store';
import { SessionStore } from '../session.store';
import { AgtBaseTreeStore } from '../core/base.tree.store';
import routes from 'routes';
import { AgtDigigFaktorUiStore, DigiFaktorSchema } from './agt.digifaktor.ui.store';
import { BerichteTreeNodes } from 'app/models/berichte/berichte.tree.nodes';
import { AgtProdGpUebersicht } from 'app/components/berichte/prod/AgtProdGpUebersicht';
import { ProdZwischenstand } from 'app/components/berichte/prod/ProdZwischenstand';
import { ProdPositionen } from 'app/components/berichte/prod/ProdPositionen';
import { DigifaktorList } from 'app/components/berichte/digifaktor/DigifaktorListe';
import { BnrProdGpUebersicht } from 'app/components/berichte/prod/BnrProdGpUebersicht';
import { DatenStand, DatenStandAkumaPrime, DatenStandDigiFaktor, DatenStandFitnessTracker, DatenStandMulitsGP, DatenStandPosZiel } from 'app/components/berichte/DatenStand';
import { AgtZielStore } from '../agt.ziel.store';
import { AgtRingPositionen } from 'app/components/berichte/ring/AgtRingPositionen';
import { AgtRingUiStore } from './agt.ring.ui.store';
import { RingOveriew } from 'app/components/berichte/ring/AgtRingOverview';
import { AgtUserUiStore } from './agt.user.ui.store';
import { AgenturClusterListe } from 'app/components/berichte/agenturcluster/AgenturClusterListe';
import { MultiSteartIds, Steart } from 'app/models/core/steart.model';
import { AkumaPlanerListe } from 'app/components/berichte/akumaplaner/AkumaPlanerListe';
import { AkumaPlanerWochenbericht } from 'app/components/berichte/akumaplaner/AkumaPlanerWochenbericht';
import { AgtHerbstList } from 'app/components/berichte/herbst/AgtHerbstList';
import { HerbstPosDefGroups } from './agt.herbstwerbung.ui.store';
import { AgtHerbstOverviewList } from 'app/components/berichte/herbst/AgtHerbstOverviewList';
import { FitnessTrackerAkuma } from 'app/components/berichte/fitnesstracker/FitnessTrackerAkuma';
import { FitnessTrackerAmisNow } from 'app/components/berichte/fitnesstracker/FitnessTrackerAmisNow';
import { FitnessTrackerGUP } from 'app/components/berichte/fitnesstracker/FitnessTrackerGUP';
import { FitnessTrackerListe } from 'app/components/berichte/fitnesstracker/FitnessTrackerListe';
import { FitnessTrackerListeExport } from 'app/components/berichte/fitnesstracker/FitnessTrackerListeExport';
import { FitnessTrackerMaz } from 'app/components/berichte/fitnesstracker/FitnessTrackerMaz';
import { AgtFitnessDetail } from 'app/components/berichte/fitnesstracker/FitnessTrackerGraphics';
import { FitnessTrackerListeGsExport } from 'app/components/berichte/fitnesstracker/FitnessTrackerListeGsExport';
import { FitnessTrackerLeadNow } from 'app/components/berichte/fitnesstracker/FitnessTrackerLeadNow';
import { AkumaMultiGpList } from 'app/components/berichte/multigp/2026/AkumaMultiGpList';
import { AkumaAktionenListe } from 'app/components/berichte/akumaaktionen/AkumaAktionenListe';
import { AkumaAktionenCampaignsListe } from 'app/components/berichte/akumaaktionen/AkumaAktionenCampaignListe';
import { AkumaAktionenOverviewListe } from 'app/components/berichte/akumaaktionen/AkumaAktionenOverviewListe';
import { AgenturListsFilter } from 'app/components/agt/AgenturListFilter';
import Config from 'Config';
import { AkumaPrimeSchemaAgt } from 'app/components/berichte/akumaprime/AkumaPrimeSchemaAgt';
import { AkumaPrimeType } from './agt.akumaprime.ui.store';
import { AkumaPrimeSchemaList } from 'app/components/berichte/akumaprime/AkumaPrimeSchemaList';
import { AkumaPrimeOverview } from 'app/components/berichte/akumaprime/AkumaPrimeAgtOverview';
import { AkumaAktionenTreffer } from 'app/components/berichte/akumaaktionen/AkumaAktionenTreffer';
import { AdzEmpfehlungList } from 'app/components/anwendungen/adzempfehlung/AdzEmpfehlungList';
import { AdzEmpfehlungPivotGs, AdzEmpfehlungPivotVD } from 'app/components/anwendungen/adzempfehlung/AdzEmpfehlungPivot';

export const GPMAXYEAR = 2026;
export const BPMAXYEAR = 2026; // moment().year();
export const RINGMAXYEAR = 2026; // moment().year();
export const BPMINYEAR = 2023;
export const CLUSTERMAXYEAR = 2026;

export class BerichteUiiStore extends AgtBaseTreeStore {
	gpStore: AgtGpStore;
	agtZielStore: AgtZielStore;
	agtDigigFaktorStore: AgtDigigFaktorUiStore;
	agtRingUiStore: AgtRingUiStore;

	constructor(
		session: SessionStore,
		agenturStore: AgenturStore,
		gpStore: AgtGpStore,
		agtZielStore: AgtZielStore,
		agtDigigFaktorStore: AgtDigigFaktorUiStore,
		agtRingUiStore: AgtRingUiStore,
		agtUserUiStore: AgtUserUiStore,
	) {
		super(session, agenturStore, agtUserUiStore);
		makeObservable(this);
		this.gpStore = gpStore;
		this.agtZielStore = agtZielStore;
		this.agtDigigFaktorStore = agtDigigFaktorStore;
		this.agtRingUiStore = agtRingUiStore;
		this.printPath = 'printbericht';
		this.menu = new TreeMenuModel(BerichteTreeNodes, this.session);

		reaction(
			() => this.session.currentUser || this.agtUserUiStore.items.length,
			() => this.fillNodesFromUser(),
			{ fireImmediately: true },
		);
	}
	onLogout() { }

	gpMaxYear: number = GPMAXYEAR;
	gpPrevYear: number = GPMAXYEAR - 1;

	async ensureLateLoadedNodes() {
		// add multis reports to nav
		if (this.session.currentSteart && this.session.currentSteart.steart === Steart.LDP) {
			await this.agtUserUiStore.load();
			const gpRoot = this.menu.findNodeByPath('production', 'gp');
			if (gpRoot) {
				gpRoot.nodes.forEach((gpCurr) => {
					this.agtUserUiStore.items.forEach((u) => {
						if (u.steart.steart === Steart.EDP || u.steart.steart === Steart.EDT) {
							const year = parseInt(gpCurr.name);
							const name = u.name + ' (' + u.steartText + ')';
							const path = 'gp_' + u.bnrId;
							const found = gpCurr.nodes.find((x) => x.name === name);
							if (found) {
								return;
							}
							gpCurr.addNode({
								name,
								path,
								agtComponent: undefined,
								component: <BnrProdGpUebersicht year={year} betreuerBnrId={u.bnrId} />,
								datenStand: u.isMulti ? <DatenStandMulitsGP year={year} /> : <DatenStandPosZiel year={year} />,
								icon: '',
								hideFilter: true,
							});
						}
					});
				});
			}
		}
	}

	fillNodesFromUser() {
		if (!this.session.currentUser) {
			return;
		}
		const currentUser = this.session.currentUser;

		this.AGENTURROUTE = routes.AGENTUR;
		this.OUTEROUTE = routes.BERICHTE;

		const gpMaxYear = this.gpMaxYear.toString();

		// gp
		const gpRoot = this.menu.findNodeByPath('production', 'gp');
		if (gpRoot) {
			if (gpRoot.nodes.find((n) => n.path === gpMaxYear)) {
				console.log('aborting fillNodesFromUser, because it seems it has run once.');
				return;
			}
			const gpCurr = gpRoot.addNode({
				name: gpMaxYear,
				path: gpMaxYear,
				icon: '',
			});
			gpCurr.addNode({
				name: 'Übersicht',
				path: 'overview',
				agtComponent: <AgtProdGpUebersicht year={this.gpMaxYear} />,
				component: <BnrProdGpUebersicht year={this.gpMaxYear} />,
				datenStand: currentUser.isMulti ? <DatenStandMulitsGP year={this.gpMaxYear} /> : <DatenStandPosZiel year={this.gpMaxYear} />,
				icon: '',
				hideFilter: true,
			});

			if (this.session.currentUser!.canSeeProdZwischenstand) {
				gpCurr.addNode({
					name: 'Produktivitäten Zwischenstand',
					path: 'prod-zwischenstand',
					component: <ProdZwischenstand year={this.gpMaxYear} />,
					datenStand: <DatenStandPosZiel year={this.gpMaxYear} />,
					icon: '',
				});
			}

			// if (!currentUser.isMulti) {
			const gpPrev = gpRoot.addNode({
				name: this.gpPrevYear.toString(),
				path: this.gpPrevYear.toString(),
				icon: '',
			});
			gpPrev.addNode({
				name: 'Übersicht',
				path: 'overview',
				agtComponent: <AgtProdGpUebersicht year={this.gpPrevYear} />,
				component: <BnrProdGpUebersicht year={this.gpPrevYear} />,
				datenStand: currentUser.isMulti ? <DatenStandMulitsGP year={this.gpPrevYear} /> : <DatenStandPosZiel year={this.gpPrevYear} />,
				icon: '',
				hideFilter: true,
			});

			if (this.session.currentUser!.canSeeProdZwischenstand) {
				gpPrev.addNode({
					name: 'Produktivitäten Zwischenstand',
					path: 'prod-zwischenstand',
					component: <ProdZwischenstand year={this.gpPrevYear} />,
					datenStand: <DatenStandPosZiel year={this.gpPrevYear} />,
					icon: '',
				});
			}
		}

		// agtPos
		const agtPosRoot = this.menu.findNodeByPath('production', 'agtpos');
		if (agtPosRoot) {
			if (agtPosRoot.nodes.find((n) => n.path === gpMaxYear)) {
				console.log('aborting fillNodesFromUser, because it seems it has run once.');
				return;
			}
			const agtCurr = agtPosRoot.addNode({
				name: gpMaxYear,
				path: gpMaxYear,
				icon: '',
			});

			this.gpStore.getAgtPositionenByGroup(this.gpMaxYear).forEach((groups) => {
				const g = groups[0];
				const groupNode = agtCurr.addNode({
					path: g.group.id,
					name: g.group.name,
					icon: '',
				});
				groups.forEach((pos) => {
					if (pos.hideFromTreeMenu) {
						return;
					}
					const eh = pos.einheit.shortText;
					groupNode.addNode({
						name: pos.posText + ` (${eh})`,
						component: <ProdPositionen year={this.gpMaxYear} />,
						path: pos.planKey,
						icon: '',
						datenStand: <DatenStandPosZiel year={this.gpMaxYear} />,
					});
				});
			});

			if (!currentUser.isMulti) {
				const agtPrev = agtPosRoot.addNode({
					name: this.gpPrevYear.toString(),
					path: this.gpPrevYear.toString(),
					icon: '',
				});
				this.gpStore.getAgtPositionenByGroup(this.gpPrevYear).forEach((groups) => {
					const g = groups[0];
					const groupNode = agtPrev.addNode({
						path: g.group.id,
						name: g.group.name,
						icon: '',
					});
					groups.forEach((pos) => {
						if (pos.hideFromTreeMenu) {
							return;
						}
						const eh = pos.einheit.shortText;
						groupNode.addNode({
							name: pos.posText + ` (${eh})`,
							component: <ProdPositionen year={this.gpPrevYear} />,
							path: pos.planKey,
							icon: '',
							datenStand: <DatenStandPosZiel year={this.gpPrevYear} />,
						});
					});
				});
			}
		}

		// ring
		const ringRoot = this.menu.findNodeByPath('production', 'ring');
		if (ringRoot) {
			const ringCurr = ringRoot.addNode({
				name: this.gpMaxYear.toString(),
				path: this.gpMaxYear.toString(),
				icon: '',
			});
			ringCurr.addNode({
				path: 'overview',
				name: 'Übersicht',
				icon: '',
				component: <RingOveriew year={this.gpMaxYear} />,
			});
			this.agtRingUiStore.ringPosGroups.forEach((ringPos) => {
				ringCurr.addNode({
					path: ringPos.goldPosId.toString(),
					name: ringPos.name,
					icon: '',
					component: <AgtRingPositionen year={this.gpMaxYear} />,
				});
			});
			const ringPrev = ringRoot.addNode({
				name: this.gpPrevYear.toString(),
				path: this.gpPrevYear.toString(),
				icon: '',
			});
			ringPrev.addNode({
				path: 'overview',
				name: 'Übersicht',
				icon: '',
				component: <RingOveriew year={this.gpPrevYear} />,
			});
			this.agtRingUiStore.ringPosGroups.forEach((ringPos) => {
				ringPrev.addNode({
					path: ringPos.goldPosId.toString(),
					name: ringPos.name,
					icon: '',
					component: <AgtRingPositionen year={this.gpPrevYear} />,
				});
			});
		}

		// herbstwerbung
		const herbstRoot = this.menu.findNodeByPath('production', 'herbst');
		if (herbstRoot) {
			const herbstCurr = herbstRoot.addNode({
				name: this.gpMaxYear.toString(),
				path: this.gpMaxYear.toString(),
				icon: '',
				// component: <AgtHerbstList year={this.gpMaxYear} />
			});
			herbstCurr.addNode({
				path: 'overview',
				name: 'Übersicht',
				icon: '',
				component: <AgtHerbstOverviewList year={this.gpMaxYear} />,
				datenStand: <DatenStand dataType="aup_gp" />,
			});
			HerbstPosDefGroups.filter((x) => x.soloPos).forEach((pos) => {
				herbstCurr.addNode({
					path: pos.posName,
					name: pos.name,
					icon: '',
					component: <AgtHerbstList year={this.gpMaxYear} pos={pos.posName} />,
					datenStand: <DatenStand dataType="aup_gp" />,
				});
			});

			// const herbstPrev = herbstRoot.addNode({
			// 	name: this.gpPrevYear.toString(),
			// 	path: this.gpPrevYear.toString(),
			// 	icon: '',
			// 	// component: <AgtHerbstList year={this.gpPrevYear} />
			// });
			// herbstPrev.addNode({
			// 	path: 'overview',
			// 	name: 'Übersicht',
			// 	icon: '',
			// 	component: <AgtHerbstOverviewList year={this.gpPrevYear} />,
			// });
			// HerbstPosDefGroups.filter(x => x.soloPos).forEach(pos => {
			// 	herbstPrev.addNode({
			// 		path: pos.posName,
			// 		name: pos.name,
			// 		icon: '',
			// 		component: <AgtHerbstList year={this.gpPrevYear} pos={pos.posName} />,
			// 	});
			// });
		}

		// akumaprime
		const akuma = this.menu.findNodeByPath('kunde', 'akuma');
		if (akuma) {
			if (akuma.nodes.find((n) => n.path === 'prime')) {
				console.log('aborting fillNodesFromUser for akuma because it seems it has run once.');
				return;
			}

			const prime = akuma.addNode({
				name: 'Prime',
				path: 'prime',
				icon: '',
			});

			prime.addNode({
				name: 'Übersicht',
				component: <AkumaPrimeOverview />,
				datenStand: <DatenStandAkumaPrime />,
				path: 'uebersicht',
				icon: '',
			});

			prime.addNode({
				name: 'Einordnung',
				component: <AkumaPrimeSchemaList primeType={AkumaPrimeType.einordnung} />,
				agtComponent: <AkumaPrimeSchemaAgt schema={AkumaPrimeType.einordnung} />,
				datenStand: <DatenStandAkumaPrime />,
				path: 'einordnung',
				icon: '',
			});
			prime.addNode({
				name: 'Terminierung',
				component: <AkumaPrimeSchemaList primeType={AkumaPrimeType.terminierung} />,
				agtComponent: <AkumaPrimeSchemaAgt schema={AkumaPrimeType.terminierung} />,
				datenStand: <DatenStandAkumaPrime />,
				path: 'terminierung',
				icon: '',
			});
			prime.addNode({
				name: 'Beziehung',
				component: <AkumaPrimeSchemaList primeType={AkumaPrimeType.beziehung} />,
				agtComponent: <AkumaPrimeSchemaAgt schema={AkumaPrimeType.beziehung} />,
				datenStand: <DatenStandAkumaPrime />,
				path: 'beziehung',
				icon: '',
			});

			const aktionen = akuma.addNode({
				name: 'Aktionen',
				path: 'aktionen',
				icon: '',
				visibileForRoles: Config.showAkumaAktionen ? undefined : [Steart.DVSADMIN]
			});
			aktionen.addNode({
				name: 'Übersicht',
				icon: '',
				path: 'overview',
				component: <AkumaAktionenOverviewListe />,
				datenStand: <DatenStand dataType="akumaaktionen" />,
				vmType: 'AkumaAktionenVM',
				visibileForRoles: Config.showAkumaAktionen ? undefined : [Steart.DVSADMIN]
			});
			aktionen.addNode({
				name: 'Aktionsbearbeitung',
				icon: '',
				path: 'campaigns',
				component: <AkumaAktionenCampaignsListe />,
				datenStand: <DatenStand dataType="akumaaktionen" />,
				vmType: 'AkumaAktionenVM',
				hideFromAgt: true,
				visibileForRoles: Config.showAkumaAktionen ? undefined : [Steart.DVSADMIN]
			});
			aktionen.addNode({
				name: 'Trefferbearbeitung',
				icon: '',
				path: 'treffer',
				component: <AkumaAktionenTreffer />,
				datenStand: <DatenStand dataType="akumaaktionen" />,
				vmType: 'AkumaAktionenVM',
				visibileForRoles: Config.showAkumaAktionen ? undefined : [Steart.DVSADMIN]
			});
			aktionen.addNode({
				name: 'Agentur Liste',
				icon: '',
				path: 'liste',
				component: <AkumaAktionenListe />,
				datenStand: <DatenStand dataType="akumaaktionen" />,
				filterComponent: <AgenturListsFilter vmType="AkumaAktionenVM" />,
				vmType: 'AkumaAktionenVM',
				visibileForRoles: Config.showAkumaAktionen ? undefined : [Steart.DVSADMIN]
			});

			const planer = akuma.addNode({
				name: 'Planer',
				path: 'planer',
				icon: '',
			});

			planer.addNode({
				name: 'Übersicht',
				component: <AkumaPlanerListe />,
				datenStand: <DatenStandAkumaPrime />,
				path: 'uebersicht',
				icon: '',
			});
			planer.addNode({
				name: 'Wochenscheiben',
				component: <AkumaPlanerWochenbericht />,
				datenStand: <DatenStandAkumaPrime />,
				path: 'wochenscheiben',
				icon: '',
			});

			akuma.addNode({
				name: 'GP Akuma Nutzung',
				path: 'gp',
				component: <AkumaMultiGpList />,
				datenStand: <DatenStandAkumaPrime />,
				icon: '',
				visibileForRoles: MultiSteartIds.concat(Steart.DVSADMIN),
				downloadPdf: { supportSavedReports: true }
			});
		}

		// Fitness Tracker
		const fitness = this.menu.findNodeByPath('bestand', 'adz', 'fit');
		if (fitness) {
			// fitness.addNode({
			// 	name: 'Print',
			// 	icon: '',
			// 	path: 'print',
			// 	component: <FitnessTrackerAgtPrint />,
			// 	datenStand: <DatenStandFitnessTracker />,
			// 	visibileForRoles: [Steart.DVSADMIN],
			// });
			fitness.addNode({
				name: 'Export',
				icon: '',
				path: 'export',
				component: <FitnessTrackerListeExport />,
				datenStand: <DatenStandFitnessTracker />,
				visibileForRoles: [Steart.DVSADMIN],
			});
			fitness.addNode({
				name: 'Export GS',
				icon: '',
				path: 'exportgs',
				component: <FitnessTrackerListeGsExport />,
				visibileForRoles: [Steart.XXX],
			});
			fitness.addNode({
				name: 'Übersicht',
				icon: '',
				path: 'overview',
				component: <FitnessTrackerListe />,
				agtComponent: <AgtFitnessDetail view="overview" />,
				datenStand: <DatenStandFitnessTracker />,
				lastPathIsParam: true,
			});
			fitness.addNode({
				name: 'Sichtbar sein DigitalPersönlich',
				icon: '',
				path: 'gup',
				component: <FitnessTrackerGUP />,
				agtComponent: <AgtFitnessDetail view="gup" />,
				datenStand: <DatenStand dataType="googleprofile" />,
				lastPathIsParam: true,
			});
			fitness.addNode({
				name: 'Jeden Kontakt nutzen',
				icon: '',
				path: 'amisnowaufgaben',
				component: <FitnessTrackerAmisNow />,
				agtComponent: <AgtFitnessDetail view="amis" />,
				datenStand: <DatenStand dataType="amisnow" />,
				lastPathIsParam: true,
			});
			fitness.addNode({
				name: 'Jeden Kunden kontaktieren',
				icon: '',
				path: 'akuma',
				component: <FitnessTrackerAkuma />,
				agtComponent: <AgtFitnessDetail view="akuma" />,
				datenStand: <DatenStandAkumaPrime />,
				lastPathIsParam: true,
			});
			fitness.addNode({
				name: 'Immer da sein',
				icon: '',
				path: 'maz',
				component: <FitnessTrackerMaz />,
				agtComponent: <AgtFitnessDetail view="maz" />,
				datenStand: <DatenStand dataType="digitalreport" />,
				lastPathIsParam: true,
			});
			fitness.addNode({
				name: 'Neue Kunden finden',
				icon: '',
				path: 'leadnow',
				component: <FitnessTrackerLeadNow />,
				agtComponent: <AgtFitnessDetail view="leadnow" />,
				datenStand: <DatenStand dataType="leadnow" />,
				lastPathIsParam: true,
			});
		}

		// const adz = this.menu.findNodeByPath('bestand', 'adz');
		// adz empfehlungen
		const adzEmpfehlungRoot = this.menu.findNodeByPath('bestand', 'adz', 'empf');
		if (adzEmpfehlungRoot) {

			for (const y of [2026, 2025]) {
				const adzYear = adzEmpfehlungRoot.addNode({
					name: y.toString(),
					path: y.toString(),
					icon: '',
				});
				adzYear.addNode({
					name: 'AdZ Empfehlungen ',
					path: y.toString(),
					component: <AdzEmpfehlungList />,
					icon: '',
				});

				adzYear.addNode({
					name: 'Nach GS ',
					path: 'gs' + y.toString(),
					component: <AdzEmpfehlungPivotGs year={y} />,
					visibileForRoles: [Steart.DVSADMIN, ...MultiSteartIds],
					icon: '',
				});

				adzYear.addNode({
					name: 'Nach VD ',
					path: 'vd' + y.toString(),
					component: <AdzEmpfehlungPivotVD year={y} />,
					visibileForRoles: [Steart.DVSADMIN],
					icon: '',
				});
			}
		}

		// digifaktor
		const dfRoot = this.menu.findNodeByPath('kunde', 'digi');
		if (dfRoot) {
			DigiFaktorSchema.forEach((d) => {
				dfRoot.addNode({
					name: d.title,
					component: <DigifaktorList />,
					datenStand: <DatenStandDigiFaktor />,
					datenStandDate: () => {
						return this.agtDigigFaktorStore.datenStand ? this.agtDigigFaktorStore.datenStand?.toString() : '';
					},
					path: d.path,
					icon: '',
				});
			});
		}

		const cluster = this.menu.findNodeByPath('bestand', 'cluster');
		if (cluster) {
			const firstYear = 2024;
			const currYear = CLUSTERMAXYEAR;
			for (let y = currYear; y >= firstYear; y--) {
				cluster.addNode({
					name: y.toString(),
					path: y.toString(),
					component: <AgenturClusterListe year={y} />,
					icon: '',
				});
			}
		}
	}

	@computed
	get currentAdzYear() {
		const s = this.menu.current!.path.split('/');
		const y = s[s.length - 1];
		const year = parseInt(y);
		return year;
	}

	menu: TreeMenuModel;
}
